export const uniqueArrayString = (array: string[]) => [...new Set(array)];
